// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.objectFit[data-v-953eb29c]{\n  max-width: 100%;\n}\n.autoSize[data-v-953eb29c]{\n   max-width: 100%;\n}\n.smallSize[data-v-953eb29c]{\n   width: 120px;\n   height: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
